export default __webpack_public_path__ + "asset/img/more-shipping-list-1~3927ef50.png";